/* ============================================================================================
   design-your-shirt-app.js — GENERATED FILE. DO NOT EDIT BY HAND.
   Docs: me/PERFORMANCE.md §1 and me/docs/dys-customizer.md

   v2 (2026-08-25): the qa-theme redesign. Presentation layer rewritten (stepper, live price
   rail/bar, receipt Review, trust badges); every state shape, onChange handler, radio name,
   cart property key and magic string preserved from v1. Pricing helpers live in
   me/src/dys-pricing.js and are concatenated ahead of the app source at build time.

   HOW TO REGENERATE after changing the component code:
     1. Sources: me/src/dys-pricing.js + me/src/design-your-shirt-app.jsx
        (headers/banner: me/src/dys-header.txt).
     2. Run: node me/bin/build-dys.mjs [--theme-dir <theme repo>] — it compiles with
        @babel/standalone 7.23.9 (pinned in me/bin/package.json), presets ['react','env'],
        compact:false, and HARD-FAILS unless the loader/fulfillment contracts hold
        (single synchronous ReactDOM.createRoot mount tail, cart property keys, magic
        strings, no residual ES2020). Tests: node me/bin/test-dys-pricing.mjs.
     3. Re-verify the builder end to end on BOTH product.design-your-shirt and
        product.order-custom-size.

   WHY presets ['react','env'] and not ['react'] alone: the source uses optional chaining and
   nullish coalescing (ES2020). `env` downlevels them, so the browser-support window is
   unchanged. Compiling with 'react' only would emit ES2020 and silently drop older browsers —
   a smaller file bought by narrowing support on a revenue-critical flow. Not worth it.

   ALL runtime data arrives via the JSON island #dys-data emitted by the section. Nothing in
   this file is product-specific, which is exactly what makes it cacheable across every
   product page. The island's value TYPES are load-bearing — get one wrong and the builder
   breaks silently:
       styleData, monogramData, contrastData,
       sizeFitSureData, sizeCollorData, sizeMeasureData
                          -> JSON *strings* (each goes through convertStringToJSON)
       variants           -> a parsed ARRAY (assigned straight to variantsJSON;
                             variant .price values are CENTS integers)
       compositionProduct -> a *string*, compared against the literal 'null'
       isAdminCustomer    -> the *string* 'true' or 'false', compared === 'true'
       productPrice       -> a *string* (it is parseInt'd; whole dollars, cents truncated)
       productPriceCents  -> v2, ADDITIVE: integer cents (bundle falls back when absent)
       product_price_cents-> v2, ADDITIVE: integer cents beside every product_price_plain
       islandVersion      -> v2, ADDITIVE: console.info skew detector, never a gate
       image              -> { w600, srcset, height } and productTitle for the rail/review
   A Render-Better-cached section can serve a v1 island beside this bundle — every v2 field
   is therefore optional with a fallback. NEVER change or remove an existing island field.
   ============================================================================================ */
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* ============================================================================================
   dys-pricing.js — pure pricing/util module for the DYS configurator.

   Concatenated AHEAD of design-your-shirt-app.jsx by brisk-docs/bin/build-dys.mjs, so every
   function here is in scope for the app. NOTHING in this file may touch the DOM, fetch, or do
   any work at module scope beyond declaring functions — the bundle executes at idle-stage
   (see the loader contract in sections/design-your-shirt.liquid).

   THE ONE RULE THAT MATTERS: buildJoinComb() is the SAME function addToCart() uses to pick the
   cart variant. The price panel shows the price of the variant this function selects, so the
   displayed total cannot diverge from the charged amount. Do not fork this logic.

   Unit-tested in plain Node (brisk-docs/bin/test-dys-pricing.mjs) against the captured island
   fixture at brisk-docs/src/fixtures/dys-island.json.
   ============================================================================================ */

/* Normalise a price to integer cents. The island's variant prices arrive as cents integers
   (verified live: 'No Add-on' -> 11900). Merchant-authored add-on fields historically arrive
   as truncated integer DOLLARS (product_price_plain) or "$5.00" display strings. Rules:
   integer number = cents; fractional number = dollars; string with '.' = dollars;
   bare-digit string = cents. */
function dysToCents(p) {
  if (typeof p === 'number' && isFinite(p)) return Number.isInteger(p) ? p : Math.round(p * 100);
  if (typeof p === 'string') {
    var s = p.replace(/[^0-9.]/g, '');
    if (!s) return 0;
    return s.indexOf('.') > -1 ? Math.round(parseFloat(s) * 100) : parseInt(s, 10) || 0;
  }
  return 0;
}
function dysFormatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* The variant-selection key. Logic extracted VERBATIM from addToCart (see the dossier §2/§6b):
   monogram axis first, then style blocks in section-block order; checkbox add-ons push the
   add-on PRODUCT title; per-option add-ons push the option's own title, but only when it names
   a linked paid product; ' | ' join; 'No Add-on' for the empty set. These strings must equal
   the store's variant option1 values exactly. */
function dysBuildJoinComb(monogramSelectedData, styleSelectedData) {
  var tempComb = [];
  monogramSelectedData['Monogram'] ? tempComb.push('Monogram') : null;
  styleSelectedData.forEach(function (item) {
    if (item.is_paid !== null) item.is_paid ? tempComb.push(item.item_paid_name) : null;
    if (item.item_paid_option !== null) {
      var tempSelectedOption = item.item_value;
      var getNames = item.item_paid_option.length && item.item_paid_option.map(function (i) {
        return i.product_name;
      });
      if (getNames.includes(tempSelectedOption)) tempComb.push(tempSelectedOption);
    }
  });
  return tempComb.length === 0 ? 'No Add-on' : tempComb.join(' | ');
}

/* ── The variant rows the app prices and adds to cart against (2026-09-11) ──────────────────
   The island historically carried `variants` = Shopify's FULL serialisation of every variant.
   Measured on the captured fixtures: 62,336 B of a 104,980 B island — 62% of it — for 72
   variants of 22 fields each, of which this app reads exactly FOUR:
       id         -> the cart line (design-your-shirt-app.jsx addToCart)
       option1    -> dysMatchVariant, the whole variant-selection contract
       price      -> dysComputePrice total and base
       available  -> the soldOut flag
   `variantsSlim` carries just those, positionally: [id, option1, price, available(1|0)].

   🚨 ADDITIVE, per invariant #24. `variants` is still emitted and is still the fallback, because
   Render Better partial-caches the section and can serve a STALE island beside a fresh bundle for
   minutes. Never make this function require the slim field. */
function dysVariantRows(island) {
  if (!island) return [];
  var slim = island.variantsSlim;
  if (slim && slim.length && Object.prototype.toString.call(slim[0]) === '[object Array]') {
    var out = new Array(slim.length);
    for (var i = 0; i < slim.length; i++) {
      var r = slim[i];
      out[i] = {
        id: r[0],
        option1: r[1],
        price: r[2],
        available: r[3] === 1 || r[3] === true
      };
    }
    return out;
  }
  return island.variants || [];
}
function dysMatchVariant(variants, joinComb) {
  if (!variants || !variants.length) return null;
  for (var i = 0; i < variants.length; i++) if (variants[i].option1 === joinComb) return variants[i];
  return null;
}

/* Itemised paid lines for the current selection, in the same order joinComb pushes tokens.
   Prices prefer the new product_price_cents island field and fall back to plain*100 (a stale
   Render-Better-cached section can serve the old island for a while — additive-field rule). */
function dysPaidLines(monogramSelectedData, styleSelectedData) {
  var lines = [];
  if (monogramSelectedData['Monogram']) {
    var mo = monogramSelectedData['Monogram Object'] || {};
    lines.push({
      label: 'Monogram',
      /* product_price_plain is integer DOLLARS (Liquid divided_by: 100) -> *100 */
      cents: mo.product_price_cents != null ? dysToCents(mo.product_price_cents) : (mo.product_price_plain || 0) * 100
    });
  }
  styleSelectedData.forEach(function (item) {
    if (item.is_paid !== null && item.is_paid) {
      lines.push({
        label: item.item_paid_name,
        cents: item.item_paid_price_cents != null ? dysToCents(item.item_paid_price_cents) : (item.item_paid_price_plain || 0) * 100
      });
    }
    if (item.item_paid_option !== null) {
      var sel = item.item_value;
      for (var i = 0; i < item.item_paid_option.length; i++) {
        var po = item.item_paid_option[i];
        if (po.product_name === sel) {
          lines.push({
            label: sel,
            cents: po.product_price_cents != null ? dysToCents(po.product_price_cents) : (po.product_price_plain || 0) * 100
          });
          break;
        }
      }
    }
  });
  return lines;
}

/* The panel model. totalCents is ALWAYS what the cart will charge (the matched variant's
   price); when no variant matches, `unavailable` is true and totalCents falls back to the
   itemised estimate so the panel can still render (ATC must be disabled by the caller).
   `reconciled` says whether base + lines equals the variant price — when false the caller
   shows base + one aggregate upgrades line (variant − base) so displayed math always sums
   to the charged amount. */
/* 2026-10-15 LIMITED DROPS: `ldPct` is the island's ldPct (theme snippets/ld-offer.liquid, decided on
   the product the cart is charged for). 0/absent = no offer and every field below is unchanged.
   ldTotalCents = totalCents less the percent, rounded half up exactly like the theme
   (price x keep + 50, integer /100), because the discount app takes it off the whole line. */
function dysLdCents(cents, pct) {
  var keep = 100 - pct;
  return Math.floor((cents * keep + 50) / 100);
}
function dysComputePrice(monogramSelectedData, styleSelectedData, variants, productPriceCents, productPrice, ldPct) {
  var joinComb = dysBuildJoinComb(monogramSelectedData, styleSelectedData);
  var matched = dysMatchVariant(variants, joinComb);
  var noAddOn = dysMatchVariant(variants, 'No Add-on');
  var baseCents = noAddOn ? dysToCents(noAddOn.price) : productPriceCents != null ? dysToCents(productPriceCents) : (parseInt(productPrice, 10) || 0) * 100;
  var lines = dysPaidLines(monogramSelectedData, styleSelectedData);
  var sum = baseCents;
  for (var i = 0; i < lines.length; i++) sum += lines[i].cents;
  var totalCents = matched ? dysToCents(matched.price) : sum;
  var pct = parseInt(ldPct, 10);
  if (!(pct > 0 && pct < 100)) pct = 0;
  return {
    joinComb: joinComb,
    matchedVariant: matched,
    unavailable: !matched,
    soldOut: !!(matched && matched.available === false),
    baseCents: baseCents,
    lines: lines,
    sumCents: sum,
    totalCents: totalCents,
    reconciled: !matched || sum === totalCents,
    ldPct: pct,
    ldTotalCents: pct ? dysLdCents(totalCents, pct) : totalCents
  };
}

/* Display-label mapping. Used ONLY in text nodes — never in value/checked/name/ids or anything
   addToCart reads ('Skip' is a fulfillment token; see the dossier). */
function dysDisplayValue(value) {
  if (typeof value === 'string' && value.toLowerCase() === 'skip') return 'None';
  return value;
}

/* Thumbnail URL for merchant-pasted Shopify CDN image URLs (they usually already carry ?v=).
   Appends a width param; never upscales beyond the source because the vectors are full-res
   PNGs displayed at <=96px (workspace rule 5 is about requesting >= source width). */
function dysThumbUrl(src, w) {
  if (!src || typeof src !== 'string') return null;
  if (src.indexOf('cdn.shopify.com') === -1 && src.indexOf('/cdn/shop/') === -1) return src;
  if (/[?&]width=/.test(src)) return src;
  return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
}

/* Display-only short fabric name: merchant fabric titles carry marketing suffixes
   ("Egyptian Pink Herringbone - Wrinkle Resistant") that wrap tile labels to 4 lines on
   phones. Text nodes only — stored values (handles/full titles) are untouched. */
function dysShortFabric(title) {
  if (typeof title !== 'string') return title;
  var i = title.indexOf(' - ');
  return i > 6 ? title.slice(0, i) : title;
}

/* Resize an already-width-parameterised Shopify CDN URL (e.g. the island's 160px contrast
   swatches) for hero display. Display only. */
function dysResizeUrl(src, w) {
  if (!src || typeof src !== 'string') return src;
  if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + w);
  return dysThumbUrl(src, w);
}

/* Display-only short label for Review rows. The size question keys are full authored
   sentences ("What waist do you wear in pants? (Pants Waist)") — the trailing parenthetical,
   when present, IS the merchant's own short name; otherwise strip the question scaffolding.
   Cart property keys are never touched. */
function dysShortKey(k) {
  if (typeof k !== 'string') return k;
  var s = k.trim();
  var m = /\(([^)]+)\)\s*$/.exec(s);
  if (m) return m[1];
  s = s.replace(/[?.!\s]+$/, '');
  var pats = [/^what'?s your\s+/i, /^what is your\s+/i, /^which option describes your\s+/i, /^select your preferred\s+/i, /^how would you like to\s+/i];
  for (var i = 0; i < pats.length; i++) {
    if (pats[i].test(s)) {
      s = s.replace(pats[i], '');
      break;
    }
  }
  return s;
}

/* ⛔ 2026-09-11: dysStyleGateMessage() lived here — it built "2 sections still need a choice —
   7 of 9 done" for the Style gate. The merchant asked for it an hour after it shipped and then
   asked for it to go ("remove 10 sections still need a choice — 0 of 10 done this"), on the
   grounds that the ready-made PDP has no such counter and the two customizers should read the
   same. The bar is back to its 2026-09-04 wording. Removed rather than left dead. */

/* Node test hook — inert in the browser. */
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    dysToCents: dysToCents,
    dysFormatMoney: dysFormatMoney,
    dysBuildJoinComb: dysBuildJoinComb,
    dysMatchVariant: dysMatchVariant,
    dysVariantRows: dysVariantRows,
    dysPaidLines: dysPaidLines,
    dysComputePrice: dysComputePrice,
    dysLdCents: dysLdCents,
    dysDisplayValue: dysDisplayValue,
    dysThumbUrl: dysThumbUrl,
    dysShortFabric: dysShortFabric,
    dysResizeUrl: dysResizeUrl,
    dysShortKey: dysShortKey
  };
}

/* Build-time compiled. Runtime data comes from the JSON island emitted by
   sections/design-your-shirt.liquid — see me/PERFORMANCE.md §1.
    v2 (2026-08-25, qa-theme redesign): presentation rewritten (stepper, price rail/bar,
   receipt Review, trust badges) — every state shape, onChange handler, radio name, cart
   property key and magic string preserved from v1. Pricing helpers (dys*) come from
   me/src/dys-pricing.js, concatenated ahead of this file by me/bin/build-dys.mjs.
   Read me/docs/dys-customizer.md before editing ANYTHING here. */
var __DYS = JSON.parse(document.getElementById('dys-data').textContent);

/* RB partial-caching can serve a stale island beside a fresh bundle; every new island
   field therefore has a fallback. This log is the skew detector, never a gate. */
if (__DYS.islandVersion !== 4 && typeof console !== 'undefined') console.info('[dys] island v' + (__DYS.islandVersion || 1) + ' with a v4 bundle — using fallbacks (Render Better cache skew; resolves on cache expiry)');

/* v4 (2026-10-12, PERF): the contrast fabric list is fetched AFTER the builder is open instead of
   being rendered by Liquid on every product page (~25 ms of cold render per fabric; 41 shown =
   ~1 s). The island now carries block_collection: null + block_collection_handle.
   Source: /collections/<handle>?view=dys-fabrics (templates/collection.dys-fabrics.liquid), about
   12 KB of exactly { title, handle, img_src (width 160), url } in collection order. ⛔ The first
   version used products.json: 1.77 MB (every variant of every fabric) parsed on the main thread,
   and it ran at mount, which is INTENT (hover/pointerdown), not open, so it competed with the
   modal opening. The merchant saw a slower open. products.json stays only as the fallback.
   WHEN: requestContrastFabrics() runs on the first Style pick or the first tab change, never at mount.
   It also runs on a placement pick and on a blocked Next / Add to Cart, so a failed load is retried
   wherever the shopper is (QA 2026-10-12: a shopper stuck on Contrast had no retry path).
   A stale v3 island still has the full list and never calls this.
   Resolves to an array (possibly empty) or rejects after one retry. */
var dysFabricCache = {};
function dysLoadContrastFabrics(handle) {
  if (dysFabricCache[handle]) return dysFabricCache[handle];
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  var base = root + 'collections/' + encodeURIComponent(handle);
  var getJSON = function getJSON(url) {
    return fetch(url, {
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  };
  var fromFeed = function fromFeed() {
    return getJSON(base + '?view=dys-fabrics').then(function (list) {
      if (!Array.isArray(list)) throw new Error('feed is not a list');
      return list;
    });
  };
  var fromProductsJson = function fromProductsJson() {
    return getJSON(base + '/products.json?limit=250').then(function (data) {
      return (data && data.products || []).map(function (pr) {
        var src = pr.images && pr.images.length ? pr.images[0].src : '';
        /* same-origin /cdn/shop/ path, as image_url prints it (no extra connection to cdn.shopify.com) */
        if (src) src = src.replace(/^https?:\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\//, '/cdn/shop/');
        if (src) src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
        return {
          title: pr.title,
          handle: pr.handle,
          img_src: src,
          url: window.location.origin + root + 'products/' + pr.handle
        };
      });
    });
  };
  var p = fromFeed()["catch"](fromProductsJson)["catch"](function () {
    return new Promise(function (res) {
      setTimeout(res, 1500);
    }).then(fromFeed)["catch"](fromProductsJson);
  });
  p["catch"](function () {
    delete dysFabricCache[handle];
  });
  dysFabricCache[handle] = p;
  return p;
}

/* Phone rails: when a group opens, bring it under the sticky stepper and center its
   selected tile. Event-handler-only DOM work (never render/stage path). */
function dysRevealOpenGroup() {
  setTimeout(function () {
    var g = document.querySelector('#design_your_shirt_modal_trigger .dys-group.is-open');
    if (!g || !g.scrollIntoView) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sel = g.querySelector('.dys-tiles input:checked');
    if (sel && sel.closest) {
      var t = sel.closest('.dys-tile');
      if (t) t.scrollIntoView({
        inline: 'center',
        block: 'nearest',
        behavior: 'auto'
      });
    }
    g.scrollIntoView({
      block: 'start',
      behavior: reduce ? 'auto' : 'smooth'
    });
  }, 60);
}

/* Size step (merchant 2026-09-03: "when I select a path to size, it should scroll my page
   to that path"): the chosen method's questions render INSIDE its card, so picking the
   third card left the form below the fold. Bring the chosen card under the sticky stepper
   the same way an opened Style group is revealed. Event-handler-only DOM work; the timeout
   lets React commit the nested panel first. */
function dysRevealChosenSize() {
  setTimeout(function () {
    /* Never the card itself: at >=750px it is display:contents (no box), so scrollIntoView
       on it is a silent no-op — verified 2026-09-03 at 1440x900.
       Phone: the LABEL (the card's header band) — the questions sit directly beneath it.
       Desktop: the PANEL. The three labels form the top row of the step, so scrolling the
       label moved the view ~50px and read as "not scrolling" (merchant screenshot,
       2026-09-03 15:41); the "path" to land on there is the questions panel beneath. */
    var desktop = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
    var sel = document.querySelector('#design_your_shirt_modal_trigger .dys-size__method.is-selected');
    if (!sel) return;
    var m = desktop ? sel.querySelector('.dys-size__panel') : sel.querySelector('label');
    if (!m || !m.scrollIntoView) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    m.scrollIntoView({
      block: 'start',
      behavior: reduce ? 'auto' : 'smooth'
    });
  }, 60);
}
var DYS_STEPS = ['style', 'contrast', 'size', 'summary'];
var DYS_STEP_LABELS = {
  style: 'Style',
  contrast: 'Contrast',
  size: 'Size',
  summary: 'Review'
};
function App(props) {
  return /*#__PURE__*/React.createElement(PopupModal, null);
}

/* Quiet trust row — same claims as the theme's guarantee strip, paper-styled. */
function TrustBadges() {
  return /*#__PURE__*/React.createElement("ul", {
    className: "dys-trust",
    "aria-label": "Our guarantees"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "15",
    height: "15",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.6",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20 6L9 17l-5-5"
  })), /*#__PURE__*/React.createElement("span", null, "Perfect Fit Guarantee")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "15",
    height: "15",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.6",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 9a8 8 0 0 1 14-3.5M20 15a8 8 0 0 1-14 3.5M18 2v4h-4M6 22v-4h4"
  })), /*#__PURE__*/React.createElement("span", null, "60-Day Free Remakes")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "15",
    height: "15",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.6",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M3 12h18M12 3c2.5 2.6 3.8 5.7 3.8 9S14.5 18.4 12 21c-2.5-2.6-3.8-5.7-3.8-9S9.5 5.6 12 3z"
  })), /*#__PURE__*/React.createElement("span", null, "Worldwide Shipping")));
}

/* The itemised receipt. Shared by the desktop rail and the Review step so the two can
   never disagree. When the merchant's variant matrix and the add-on product prices
   disagree (live data does today), the itemised lines are replaced by one aggregate
   upgrades line so the visible math always sums to the charged amount. */
function PriceReceipt(_ref) {
  var price = _ref.price,
    compact = _ref.compact;
  var showLines = price.reconciled && price.lines.length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: 'dys-receipt' + (compact ? ' dys-receipt--compact' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "dys-receipt__row"
  }, /*#__PURE__*/React.createElement("span", null, "Shirt"), /*#__PURE__*/React.createElement("span", {
    className: "dys-money"
  }, dysFormatMoney(price.baseCents))), showLines && price.lines.map(function (line) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dys-receipt__row dys-receipt__row--addon"
    }, /*#__PURE__*/React.createElement("span", null, line.label), /*#__PURE__*/React.createElement("span", {
      className: "dys-money"
    }, "+", dysFormatMoney(line.cents)));
  }), !showLines && !price.unavailable && price.totalCents !== price.baseCents && /*#__PURE__*/React.createElement("div", {
    className: "dys-receipt__row dys-receipt__row--addon"
  }, /*#__PURE__*/React.createElement("span", null, "Selected upgrades"), /*#__PURE__*/React.createElement("span", {
    className: "dys-money"
  }, "+", dysFormatMoney(price.totalCents - price.baseCents))), price.unavailable && /*#__PURE__*/React.createElement("p", {
    className: "dys-receipt__warn",
    role: "status"
  }, "This combination is temporarily unavailable."),
  /* 2026-10-15 Limited Drops: the discount line + the struck full total. Shown only when the
     island says the charged product is on offer (price.ldPct > 0). */
  price.ldPct > 0 && !price.unavailable && /*#__PURE__*/React.createElement("div", {
    className: "dys-receipt__row dys-receipt__row--ld"
  }, /*#__PURE__*/React.createElement("span", null, "Limited Drops ", /*#__PURE__*/React.createElement("span", {
    className: "dys-ld-chip"
  }, price.ldPct, "% off")), /*#__PURE__*/React.createElement("span", {
    className: "dys-money"
  }, "\u2212", dysFormatMoney(price.totalCents - price.ldTotalCents))), /*#__PURE__*/React.createElement("div", {
    className: "dys-receipt__total"
  }, /*#__PURE__*/React.createElement("span", null, "Total"), /*#__PURE__*/React.createElement("span", {
    className: "dys-money"
  }, price.ldPct > 0 && !price.unavailable && /*#__PURE__*/React.createElement("s", {
    className: "dys-was"
  }, dysFormatMoney(price.totalCents)), dysFormatMoney(price.ldTotalCents), " ", /*#__PURE__*/React.createElement("small", null, "USD"))));
}

/* Desktop-only left rail: the tailor's docket. */
function PriceRail(_ref2) {
  var price = _ref2.price;
  return /*#__PURE__*/React.createElement("aside", {
    className: "dys-rail",
    "aria-label": "Your shirt so far"
  }, /*#__PURE__*/React.createElement("p", {
    className: "dys-eyebrow"
  }, "Your shirt"), /*#__PURE__*/React.createElement("div", {
    className: "dys-rail__fabric"
  }, /*#__PURE__*/React.createElement("img", {
    src: __DYS.image.w600,
    srcSet: __DYS.image.srcset,
    sizes: "56px",
    width: "56",
    height: "70",
    loading: "lazy",
    decoding: "async",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "dys-rail__fabric-id"
  }, /*#__PURE__*/React.createElement("p", {
    className: "dys-rail__fabric-kicker"
  }, "Fabric"), /*#__PURE__*/React.createElement("p", {
    className: "dys-rail__name"
  }, __DYS.productTitle))), /*#__PURE__*/React.createElement(PriceReceipt, {
    price: price
  }), /*#__PURE__*/React.createElement(TrustBadges, null));
}
function PopupModal(props) {
  var styleDataString = __DYS.styleData;
  var monogramString = __DYS.monogramData;
  var contrastString = __DYS.contrastData;
  var sizeFitSureString = __DYS.sizeFitSureData;
  var sizeCollorString = __DYS.sizeCollorData;
  var sizeMeasureString = __DYS.sizeMeasureData;
  /* Slim rows when the island has them, Shopify's fat array when it does not — see
     dysVariantRows() in dys-pricing.js. The downstream shape is identical either way. */
  var variantsString = dysVariantRows(__DYS);
  var compositionProduct = __DYS.compositionProduct;

  // Convert Shopify String into JSON
  var convertStringToJSON = function convertStringToJSON(getDta) {
    return JSON.parse(getDta.replace(/\t|\r|\n|\s\s+/gm, ""));
  };
  var styleDataJSON = convertStringToJSON(styleDataString);
  var monogramDataJSON = convertStringToJSON(monogramString);
  var contrastDataJSON = convertStringToJSON(contrastString);
  var sizeDataJSON = [{
    item_name: convertStringToJSON(sizeFitSureString)[0].block_name,
    item_options: convertStringToJSON(sizeFitSureString)
  }, {
    item_name: convertStringToJSON(sizeCollorString)[0].block_name,
    item_options: convertStringToJSON(sizeCollorString)
  }, {
    item_name: convertStringToJSON(sizeMeasureString)[0].block_name,
    item_options: convertStringToJSON(sizeMeasureString)
  }];

  // Modify Data
  var reFactStyle = function reFactStyle(styleDataJS) {
    var output = {
      tab_name: styleDataJS[0].block_name,
      tab_type: styleDataJS[0].block_type,
      tab_items: []
    };
    for (var i = 0; i < styleDataJS.length; i++) {
      var obj = {
        item_title: styleDataJS[i].block_title,
        item_id: styleDataJS[i].block_id,
        item_paid: styleDataJS[i].block_paid_option_product,
        item_options: []
      };
      for (var j = 0; j < styleDataJS[i].block_options.length; j++) {
        var key4Obj = styleDataJS[i].block_options[j];
        var key5Obj = styleDataJS[i].block_vectors[j];
        var mergedObj = _objectSpread(_objectSpread({}, key4Obj), key5Obj);
        obj.item_options.push(mergedObj);
      }
      output.tab_items.push(obj);
    }
    return output;
  };

  // set default Values Style
  var setDefaultSelected = function setDefaultSelected() {
    /* v2.2 (2026-09-04, merchant): NO option is preselected in any Style section — the row
       shows an em dash until the shopper picks (the Size step made the same move on
       2026-08-31). item_value '' prices as the base variant (dysBuildJoinComb finds no paid
       option name) and never reaches the cart: styleValidate blocks Next until every section
       has a real pick, so `Style - <group>` is only ever written by one. */
    var tempObj = [];
    styleMeta.tab_items.forEach(function (item, index) {
      var _item$item_paid, _item$item_paid2, _item$item_paid3, _item$item_paid4, _item$item_paid5;
      tempObj.push({
        item_title: item === null || item === void 0 ? void 0 : item.item_title,
        item_id: item === null || item === void 0 ? void 0 : item.item_id,
        item_value: '',
        is_paid: (item === null || item === void 0 ? void 0 : item.item_paid) !== null ? false : null,
        item_paid_name: (item === null || item === void 0 ? void 0 : item.item_paid) !== null ? item === null || item === void 0 || (_item$item_paid = item.item_paid) === null || _item$item_paid === void 0 ? void 0 : _item$item_paid.product_name : null,
        item_paid_price: (item === null || item === void 0 ? void 0 : item.item_paid) !== null ? item === null || item === void 0 || (_item$item_paid2 = item.item_paid) === null || _item$item_paid2 === void 0 ? void 0 : _item$item_paid2.product_price : null,
        item_paid_price_plain: (item === null || item === void 0 ? void 0 : item.item_paid) !== null ? item === null || item === void 0 || (_item$item_paid3 = item.item_paid) === null || _item$item_paid3 === void 0 ? void 0 : _item$item_paid3.product_price_plain : null,
        /* v2: cents from the island when present (additive field; stale-cache fallback = plain*100 in dys-pricing) */
        item_paid_price_cents: (item === null || item === void 0 ? void 0 : item.item_paid) !== null && (item === null || item === void 0 || (_item$item_paid4 = item.item_paid) === null || _item$item_paid4 === void 0 ? void 0 : _item$item_paid4.product_price_cents) != null ? item === null || item === void 0 || (_item$item_paid5 = item.item_paid) === null || _item$item_paid5 === void 0 ? void 0 : _item$item_paid5.product_price_cents : null,
        item_paid_title: "".concat(item === null || item === void 0 ? void 0 : item.item_title, " Add-on"),
        item_paid_option: item !== null && item !== void 0 && item.item_options.filter(function (obj) {
          return obj.paid_item !== null;
        }).map(function (obj) {
          return obj;
        }).length ? item === null || item === void 0 ? void 0 : item.item_options.filter(function (obj) {
          return obj.paid_item !== null;
        }).map(function (obj) {
          return obj.paid_item;
        }) : null
      });
    });
    setStyleSelectedData(tempObj);
  };
  var setDefaultSelectedMonogram = function setDefaultSelectedMonogram() {
    var textFiled = monogramMeta.block_name + ' Text';
    var tempData = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, monogramMeta.block_name, false), textFiled, ""), "".concat(monogramMeta.block_name, " ").concat(monogramMeta.block_option_1.title), monogramMeta.block_option_1.options[0].title), "".concat(monogramMeta.block_name, " ").concat(monogramMeta.block_option_2.title), monogramMeta.block_option_2.options[0].title), "".concat(monogramMeta.block_name, " ").concat(monogramMeta.block_option_3.title), monogramMeta.block_option_3.options[0].title), "".concat(monogramMeta.block_name, " Object"), monogramMeta.block_product !== null ? monogramMeta.block_product : null);
    setMonogramSelectedData(tempData);
  };
  var setDefaultSelectedContrast = function setDefaultSelectedContrast() {
    var tempData = {};
    contrastMeta.forEach(function (item) {
      var itemName = (item === null || item === void 0 ? void 0 : item.block_title) + ' ' + (item === null || item === void 0 ? void 0 : item.block_name);
      tempData[item === null || item === void 0 ? void 0 : item.block_title] = item !== null && item !== void 0 && item.block_options ? item === null || item === void 0 ? void 0 : item.block_options[0].title : "";
      tempData[itemName] = item !== null && item !== void 0 && item.block_collection ? item === null || item === void 0 ? void 0 : item.block_collection[0].handle : "";
    });
    setContrastSelectedData(tempData);
  };
  var setDefaultSelectedSize = function setDefaultSelectedSize() {
    /* v2.1 (2026-08-31, merchant): no sizing method is preselected — the shopper must
       choose one deliberately. The 'Size' key is only written by their pick (its value,
       when set, stays the full authored string — it is a cart property). The forward
       gate in sizeOptionsValidate blocks Next until a method is chosen. */
    setSizeSelectedData({});
  };

  // onChangeStyle function
  var onChangeStyle = function onChangeStyle(event, index) {
    requestContrastFabrics();
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value,
      checked = _event$target.checked,
      type = _event$target.type;
    var temData = Object.assign([], styleSelectedData);
    if (type === 'checkbox') {
      temData[index].is_paid = checked;
    } else {
      temData[index].item_value = value;
    }
    setStyleSelectedData(temData);
  };

  // onChangeMonogram swatch
  var onChangeMonogram = function onChangeMonogram(event) {
    var _event$target2 = event.target,
      name = _event$target2.name,
      value = _event$target2.value,
      checked = _event$target2.checked,
      type = _event$target2.type;
    var temData = Object.assign({}, monogramSelectedData);
    if (type === 'checkbox') {
      temData[name] = checked;
    } else if (type === 'radio' || type === "text" || type === 'number') {
      temData[name] = value;
    }
    setMonogramSelectedData(temData);
  };
  var onChangeContrast = function onChangeContrast(event) {
    requestContrastFabrics(); /* v4: a no-op once loaded; retries a failed load when a placement is picked */
    var _event$target3 = event.target,
      value = _event$target3.value,
      name = _event$target3.name;
    var tempData = Object.assign({}, contrastSelectedData);
    tempData[name] = value;
    setContrastSelectedData(tempData);
  };
  var onChangeSize = function onChangeSize(event) {
    var _event$target4 = event.target,
      name = _event$target4.name,
      value = _event$target4.value;
    var tempData = Object.assign({}, sizeSelectedData);
    tempData[name] = value;
    setSizeSelectedData(tempData);
    dysRevealChosenSize();
  };
  var onChangeSizeSub = function onChangeSizeSub() {
    var _event$target5 = event.target,
      name = _event$target5.name,
      value = _event$target5.value;
    var tempData = Object.assign({}, sizeOptionSelectedData);
    tempData[name] = value;
    setSizeOptionSelectedData(tempData);
  };
  var handleTabClick = function handleTabClick(tab) {
    requestContrastFabrics();
    setActiveTab(tab);
  };

  // Check monogram validation
  // v2 changes (only): failure sets monogramErrorsVisible (inline message appears only
  // after a blocked Next, not on first paint) and OPENS the Monogram group first —
  // reportValidity() cannot focus a control inside a closed (display:none) group, so
  // the report is deferred one tick past the re-render that reveals it.
  var mongramValidation = function mongramValidation(tabID) {
    var mongramFormRef = document.getElementById('monogramFormRef');
    if (mongramFormRef) {
      if (!mongramFormRef[0].checkValidity()) {
        setMonogramErrorsVisible(true);
        setActiveStyleGroup(monogramMeta.block_name);
        setTimeout(function () {
          var f = document.getElementById('monogramFormRef');
          if (f && f[0]) f[0].reportValidity();
        }, 60);
      } else {
        handleTabClick(tabID);
      }
    } else {
      handleTabClick(tabID);
    }
  };

  // v2 changes (only): the form ref is looked up at CALL time (v1 captured it during
  // render, where it was null on first paint and the Next button silently no-opped),
  // and failure sets sizeErrorsVisible for the inline messages.
  var sizeOptionsValidate = function sizeOptionsValidate(tabID) {
    /* no method chosen yet: block and say so (v1 preselected the first method, so this
       branch could not occur; the silent no-op below it never fired either) */
    if (!sizeSelectedData['Size']) {
      setSizeErrorsVisible(true);
      return;
    }
    var sizeOptionsFormRef = document.getElementById('sizeOptionsForm');
    if (sizeOptionsFormRef) {
      if (!sizeOptionsFormRef.checkValidity()) {
        setSizeErrorsVisible(true);
        sizeOptionsFormRef.reportValidity();
      } else {
        handleTabClick(tabID);
      }
    }
  };

  /* v2.2 (2026-09-04): Style forward gate. Nothing is preselected any more, so a shopper can
     press Next with sections still empty; block, show the message in the bar's status line
     (always visible — a message above the groups scrolled out of view) and open the FIRST
     incomplete section. The reveal scroll here is deliberate and is NOT the auto-advance
     scroll the merchant removed the same day (advanceStyleGroup) — on a blocked Next the
     section to fill must come into view, exactly as the Size gate surfaces its message. */
  var styleValidate = function styleValidate(tabID) {
    for (var i = 0; i < styleSelectedData.length; i++) {
      if (!styleSelectedData[i].item_value) {
        setStyleErrorsVisible(true);
        setActiveStyleGroup(styleSelectedData[i].item_title);
        dysRevealOpenGroup();
        return;
      }
    }
    mongramValidation(tabID);
  };

  /* v2 rewrite. v1's guard chain had a precedence bug ((a && b) || c) that made the
     Contrast tab clickable from anywhere, and the Summary tab had no onClick at all.
     Model now: backward (or any step already reached, tracked by maxStep) is free;
     forward runs the validation gate of the step being left. Property keys, state and
     the validators themselves are untouched. */
  var nextTab = function nextTab(tabID, isNextBtn) {
    var from = DYS_STEPS.indexOf(activeTab);
    var to = DYS_STEPS.indexOf(tabID);
    if (to === from) return;
    if (to < from || to <= maxStep) {
      handleTabClick(tabID);
      return;
    }
    if (activeTab === 'style') {
      styleValidate(tabID);
      return;
    }
    if (activeTab === 'contrast') {
      if (contrastFabricMissing()) {
        requestContrastFabrics();
        setAtcError(DYS_FABRIC_WAIT);
        return;
      }
      if (atcError === DYS_FABRIC_WAIT) setAtcError('');
      handleTabClick(tabID);
      return;
    }
    if (activeTab === 'size') {
      sizeOptionsValidate(tabID);
      return;
    }
    handleTabClick(tabID);
  };
  var addToCart = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var variantsJSON, joinComb, selectedVariant, tempData, payload;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            variantsJSON = variantsString;
            /* v2: joinComb comes from the SAME pure helper the price panel uses
               (dys-pricing.js, logic extracted verbatim from v1) — displayed price and
               charged variant cannot diverge. */
            joinComb = dysBuildJoinComb(monogramSelectedData, styleSelectedData);
            selectedVariant = variantsJSON.filter(function (item) {
              return item.option1 === joinComb;
            });
            /* v2 guard: v1 threw an unhandled TypeError here on a missing variant row and the
               shopper saw nothing. */
            if (selectedVariant.length) {
              _context.next = 7;
              break;
            }
            setAtcError('This combination is temporarily unavailable. Please adjust a selection or contact us.');
            if (typeof console !== 'undefined') console.warn('[dys] no variant with option1 ===', joinComb);
            return _context.abrupt("return");
          case 7:
            if (!contrastFabricMissing()) {
              _context.next = 11;
              break;
            }
            requestContrastFabrics();
            setAtcError(DYS_FABRIC_WAIT);
            return _context.abrupt("return");
          case 11:
            tempData = {};
            styleSelectedData.length && styleSelectedData.map(function (i) {
              var tempKey = "Style - ".concat(i.item_title);
              tempData[tempKey] = i.item_value;
            });
            if (monogramSelectedData['Monogram']) {
              Object.keys(monogramSelectedData).map(function (i) {
                if (i !== 'Monogram Object') tempData[i] = monogramSelectedData[i];
              });
            }
            Object.keys(contrastSelectedData).map(function (i) {
              var tempKey = "Contrast - ".concat(i);
              if (!i.includes('Contrast')) {
                tempData[tempKey] = contrastSelectedData[i];
                if (contrastSelectedData[i].toLowerCase() !== 'skip') {
                  tempData["".concat(tempKey, " Contrast")] = contrastSelectedData["".concat(i, " Contrast")];
                }
              }
            });
            Object.keys(sizeSelectedData).map(function (i) {
              var tempKey = "".concat(i);
              tempData[tempKey] = sizeSelectedData[i];
            });
            Object.keys(sizeOptionSelectedData).map(function (i) {
              var tempKey = "".concat(i);
              tempData[tempKey] = sizeOptionSelectedData[i];
            });
            if (compositionProduct !== 'null') {
              tempData['_Product Composition'] = compositionProduct;
            }
            payload = {
              items: [{
                quantity: 1,
                id: selectedVariant[0].id,
                properties: tempData
              }]
            };
            _context.next = 21;
            return APICall(payload);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function addToCart() {
      return _ref3.apply(this, arguments);
    };
  }();
  var getCombination = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var mainArra, priceArra, monogramOptions, monogramPriceTemp, tempPriceArra, combinations, priceCombinations, generateCombinations, generatePriceCombinations, tempComp, finalCombinations, finalPriceCombinations;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            generatePriceCombinations = function _generatePriceCombina(index, current) {
              if (index === priceArra.length) {
                priceCombinations.push(current);
                return;
              }
              for (var i = 0; i < priceArra[index].length; i++) {
                generatePriceCombinations(index + 1, [].concat(_toConsumableArray(current), [priceArra[index][i]]));
              }
            };
            generateCombinations = function _generateCombinations(index, current) {
              if (index === mainArra.length) {
                combinations.push(current);
                return;
              }
              for (var i = 0; i < mainArra[index].length; i++) {
                generateCombinations(index + 1, [].concat(_toConsumableArray(current), [mainArra[index][i]]));
              }
            };
            // console.log('Ge Combination');
            mainArra = [];
            priceArra = [];
            monogramOptions = ['-', 'Monogram'];
            monogramPriceTemp = monogramSelectedData['Monogram Object'] !== null ? monogramSelectedData['Monogram Object'].product_price_plain : 0;
            tempPriceArra = [0, monogramPriceTemp];
            mainArra.push(monogramOptions);
            priceArra.push(tempPriceArra);
            styleSelectedData.forEach(function (item) {
              if (item.is_paid !== null) {
                var tempArra = ["-", "".concat(item.item_paid_name)];
                mainArra.push(tempArra);
                priceArra.push(tempPriceArra);
              }
              if (item.item_paid_option !== null) {
                var _tempArra = ['-'];
                var _tempPriceArra = [0];
                item.item_paid_option.length && item.item_paid_option.forEach(function (i) {
                  _tempArra.push(i.product_name);
                  _tempPriceArra.push(i.product_price_plain);
                });
                mainArra.push(_tempArra);
                priceArra.push(_tempPriceArra);
              }
            });
            combinations = [];
            priceCombinations = [];
            generateCombinations(0, []);
            generatePriceCombinations(0, []);
            _context2.next = 16;
            return combinations.map(function (value) {
              var tempInnerComb = value.filter(function (i) {
                return i !== '-';
              });
              if (tempInnerComb.length) return tempInnerComb;else return ['No Add-on'];
            });
          case 16:
            tempComp = _context2.sent;
            finalCombinations = tempComp.map(function (i) {
              return i.join(' | ');
            });
            finalPriceCombinations = priceCombinations.map(function (innerArr) {
              var sum = innerArr.reduce(function (acc, curr) {
                return acc + curr;
              }, 0);
              return sum;
            });
            setVariantComb(finalCombinations);
            setVariantCombPrice(finalPriceCombinations);
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getCombination() {
      return _ref4.apply(this, arguments);
    };
  }();
  var APICall = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(payload) {
      var res, data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            setIsLoading(true);
            setAtcError('');
            _context3.next = 5;
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(payload)
            });
          case 5:
            res = _context3.sent;
            if (res.ok) {
              _context3.next = 8;
              break;
            }
            throw res;
          case 8:
            _context3.next = 10;
            return res.json();
          case 10:
            data = _context3.sent;
            setIsLoading(false);
            document.querySelector('[data-bs-dismiss="modal"]').click();
            document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
              bubbles: true,
              cancelable: false,
              detail: {
                openDrawer: true
              }
            }));

            // To save current selections
            if (isCurrentSave) {
              saveCurrentSelections();
            }
            setDefaultSelected();
            setDefaultSelectedMonogram();
            setDefaultSelectedContrast();
            setDefaultSelectedSize();
            setActiveTab('style');
            return _context3.abrupt("return", data);
          case 23:
            _context3.prev = 23;
            _context3.t0 = _context3["catch"](0);
            setIsLoading(false);
            /* v2: v1 swallowed this entirely — a 422 looked like success minus the drawer. */
            setAtcError('Something went wrong adding your shirt to the cart. Please try again.');
            if (typeof console !== 'undefined') console.warn('[dys] cart/add failed', _context3.t0 && _context3.t0.status);
          case 28:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 23]]);
    }));
    return function APICall(_x) {
      return _ref5.apply(this, arguments);
    };
  }();

  // Current Selections Settings.
  var onChangeCurrentSave = function onChangeCurrentSave() {
    var checked = event.target.checked;
    setIsCurrentSave(checked);
  };
  var saveCurrentSelections = function saveCurrentSelections() {
    var temp = {
      styleSelectedData: styleSelectedData,
      monogramSelectedData: monogramSelectedData,
      contrastSelectedData: contrastSelectedData,
      sizeSelectedData: sizeSelectedData,
      sizeOptionSelectedData: sizeOptionSelectedData
    };
    localStorage.setItem('currentSelection', JSON.stringify(temp));
  };
  var loadSavedSelectionSettings = function loadSavedSelectionSettings() {
    var getLocalStorage = localStorage.getItem("currentSelection");
    if (getLocalStorage !== null) {
      var getLocalStorageParse = JSON.parse(getLocalStorage);
      setStyleSelectedData(getLocalStorageParse.styleSelectedData);
      setMonogramSelectedData(getLocalStorageParse.monogramSelectedData);
      setContrastSelectedData(getLocalStorageParse.contrastSelectedData);
      setSizeSelectedData(getLocalStorageParse.sizeSelectedData);
      setTimeout(function () {
        setSizeOptionSelectedData(getLocalStorageParse.sizeOptionSelectedData);
      }, 300);
    }
  };
  var checkHasInStorage = function checkHasInStorage() {
    var getLocalStorage = localStorage.getItem("currentSelection");
    if (getLocalStorage !== null) {
      var getLocalStorageParse = JSON.parse(getLocalStorage);
      if (getLocalStorageParse) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  // RawData
  var _React$useState = React.useState('style'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeTab = _React$useState2[0],
    setActiveTab = _React$useState2[1];
  var _React$useState3 = React.useState(reFactStyle(styleDataJSON)),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    styleMeta = _React$useState4[0],
    setStyleMeta = _React$useState4[1];
  var _React$useState5 = React.useState(monogramDataJSON[0]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    monogramMeta = _React$useState6[0],
    setMonogramMeta = _React$useState6[1];
  var _React$useState7 = React.useState(contrastDataJSON),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    contrastMeta = _React$useState8[0],
    setcontrastMeta = _React$useState8[1];
  var _React$useState9 = React.useState(sizeDataJSON),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    sizeMeta = _React$useState10[0],
    setSizetMeta = _React$useState10[1];
  var _React$useState11 = React.useState([]),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    styleSelectedData = _React$useState12[0],
    setStyleSelectedData = _React$useState12[1];
  var _React$useState13 = React.useState({}),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    monogramSelectedData = _React$useState14[0],
    setMonogramSelectedData = _React$useState14[1];
  var _React$useState15 = React.useState({}),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    contrastSelectedData = _React$useState16[0],
    setContrastSelectedData = _React$useState16[1];
  var _React$useState17 = React.useState({}),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    sizeSelectedData = _React$useState18[0],
    setSizeSelectedData = _React$useState18[1];
  var _React$useState19 = React.useState({}),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    sizeOptionSelectedData = _React$useState20[0],
    setSizeOptionSelectedData = _React$useState20[1];
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    isLoading = _React$useState22[0],
    setIsLoading = _React$useState22[1];
  var _React$useState23 = React.useState([]),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    variantComb = _React$useState24[0],
    setVariantComb = _React$useState24[1];
  var _React$useState25 = React.useState([]),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    variantCombPrice = _React$useState26[0],
    setVariantCombPrice = _React$useState26[1];
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    isCurrentSave = _React$useState28[0],
    setIsCurrentSave = _React$useState28[1];

  /* v2 UI state (presentation only — none of it reaches the cart payload) */
  var _React$useState29 = React.useState(0),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    maxStep = _React$useState30[0],
    setMaxStep = _React$useState30[1];
  var _React$useState31 = React.useState(reFactStyle(styleDataJSON).tab_items[0].item_title),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    activeStyleGroup = _React$useState32[0],
    setActiveStyleGroup = _React$useState32[1];
  var _React$useState33 = React.useState(''),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    atcError = _React$useState34[0],
    setAtcError = _React$useState34[1];
  var _React$useState35 = React.useState(false),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    sizeErrorsVisible = _React$useState36[0],
    setSizeErrorsVisible = _React$useState36[1];
  var _React$useState37 = React.useState(false),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    styleErrorsVisible = _React$useState38[0],
    setStyleErrorsVisible = _React$useState38[1]; /* v2.2 Style gate message */
  var _React$useState39 = React.useState(false),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    receiptOpen = _React$useState40[0],
    setReceiptOpen = _React$useState40[1]; /* phone tap-total mini receipt */
  /* perf: decorative media (row thumbnails, lead fabric photo) mount only after the modal has
     finished opening — their decode used to sit on the click→visible path (~40% on slow phones) */
  var _React$useState41 = React.useState(false),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    mediaReady = _React$useState42[0],
    setMediaReady = _React$useState42[1];
  var _React$useState43 = React.useState(false),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    monogramErrorsVisible = _React$useState44[0],
    setMonogramErrorsVisible = _React$useState44[1];
  var isAdminCustomer = __DYS.isAdminCustomer;
  var productPrice = __DYS.productPrice;
  React.useEffect(function () {
    setDefaultSelected();
    setDefaultSelectedMonogram();
    setDefaultSelectedContrast();
    setDefaultSelectedSize();
  }, []);

  /* v4: fill block_collection for blocks the island left empty, then give every placement whose
     fabric is still blank the first fabric — exactly the default setDefaultSelectedContrast()
     used to write when Liquid printed the list. A fabric the shopper (or a restored session)
     already chose is never overwritten. Called from onChangeStyle and handleTabClick, so it starts
     only once the builder is open and in use. Safe to call repeatedly: the fetch is cached per
     handle and the fills only touch blanks. */
  var requestContrastFabrics = function requestContrastFabrics() {
    contrastMeta.forEach(function (block) {
      if (block.block_collection || !block.block_collection_handle) return;
      dysLoadContrastFabrics(block.block_collection_handle).then(function (list) {
        setcontrastMeta(function (prev) {
          return prev.map(function (b) {
            return !b.block_collection && b.block_collection_handle === block.block_collection_handle ? Object.assign({}, b, {
              block_collection: list,
              block_collection_error: false
            }) : b;
          });
        });
        if (!list.length) return;
        setContrastSelectedData(function (prev) {
          var next = Object.assign({}, prev);
          contrastMeta.forEach(function (b) {
            if (b.block_collection_handle !== block.block_collection_handle) return;
            var key = b.block_title + ' ' + b.block_name;
            if (!next[key]) next[key] = list[0].handle;
          });
          return next;
        });
      })["catch"](function () {
        setcontrastMeta(function (prev) {
          return prev.map(function (b) {
            return b.block_collection_handle === block.block_collection_handle && !b.block_collection ? Object.assign({}, b, {
              block_collection_error: true
            }) : b;
          });
        });
      });
    });
  };

  /* v4: a placement with no fabric (list still loading, or it failed) must never reach the cart —
     fulfilment needs the fabric handle. Before v4 this could not happen (Liquid always printed
     the list, and the first fabric was the default). */
  var contrastFabricMissing = function contrastFabricMissing() {
    return contrastMeta.some(function (b) {
      var pl = contrastSelectedData[b.block_title];
      return pl && pl.toLowerCase() !== 'skip' && !contrastSelectedData[b.block_title + ' ' + b.block_name];
    });
  };
  var DYS_FABRIC_WAIT = 'Contrast fabrics have not loaded yet. Wait a moment, or refresh the page.';
  React.useEffect(function () {
    sizeDataJSON.forEach(function (item, index) {
      if (item.item_options[0].block_title === sizeSelectedData['Size']) {
        var tempData = {};
        item.item_options.length && item.item_options.forEach(function (sub_item, sub_index) {
          if (sub_item.block_input_type === 'swatch' || sub_item.block_input_type === 'dropdown') {
            tempData[sub_item.block_option_title] = "";
          } else if (sub_item.block_input_type === 'input_field') {
            sub_item.block_options.length && sub_item.block_options.forEach(function (j) {
              var tempKey = "".concat(sub_item.block_option_title, " (").concat(j.title, ")");
              tempData[tempKey] = "";
            });
          }
        });
        setSizeOptionSelectedData(tempData);
      }
    });
  }, [sizeSelectedData]);

  /* v2: the furthest step the shopper has legitimately reached — completed steps stay
     clickable in the stepper; forward jumps beyond it stay gated. */
  React.useEffect(function () {
    setMaxStep(function (m) {
      return Math.max(m, DYS_STEPS.indexOf(activeTab));
    });
  }, [activeTab]);

  /* switching sizing method builds a fresh empty sub-form — stale red messages from a
     previously blocked Next must not greet it */
  React.useEffect(function () {
    setSizeErrorsVisible(false);
  }, [sizeSelectedData]);
  React.useEffect(function () {
    setReceiptOpen(false); /* the mini receipt never survives a step change */
  }, [activeTab]);

  /* the Style gate message clears itself once every section has a pick */
  React.useEffect(function () {
    if (styleErrorsVisible && styleSelectedData.length && styleSelectedData.every(function (i) {
      return !!i.item_value;
    })) setStyleErrorsVisible(false);
  }, [styleSelectedData]);

  /* ── media is ready as soon as the app mounts (2026-09-11) ───────────────────────────────
     Merchant: "it is very important the images in dys customizer are instantly visible."
      This used to wait for `shown.bs.modal`, i.e. the END of the 240 ms desktop / 280 ms phone
     open motion, with a 4 s fallback if the event was missed. That was correct when mount and
     open were the same moment (2026-08-25): decoding the lead fabric photo and the row thumbs
     inside the opening frame cost ~40% of the open on a slow phone, so they were deferred.
      They are no longer the same moment. Since the staging rework the app MOUNTS ON INTENT —
     pointerenter / touchstart / focusin on the trigger (see the loader's TRIGGERS binding in
     sections/design-your-shirt.liquid) — which lands before the click on both form factors.
     Fetch and decode therefore happen in the gap between reaching for the button and the
     sheet arriving, and the pictures are simply there when it opens.
      ⚠ What this costs: a shopper who hovers the trigger and never clicks now also fetches the
     lead photo and the row thumbs. The option tiles in the open group already fetched at mount
     before this change, so the increment is a handful of images, and only for someone who
     reached for the button. The pre-intent contract is untouched and still asserted in QA:
     ZERO option-vector requests before intent.
     ⚠ Keep every <img> `loading="lazy"`. The sheet's responsive twins (the >=750px rail photo
     and the phone identity thumb) are 0x0 at the width where they are hidden, and lazy is what
     stops the hidden one being fetched. */
  React.useEffect(function () {
    setMediaReady(true);
  }, []);

  /* Live price — plain recomputation every render, deliberately NO memoization: the
     selection states are mutated in place (v1 pattern, kept), so dependency arrays
     would go stale. A scan over ~72 variants is microseconds. */
  var price = dysComputePrice(monogramSelectedData, styleSelectedData, variantsString, __DYS.productPriceCents, productPrice, __DYS.ldPct);

  /* Review "Edit" targets and auto-advance for the Style accordion. DOM scroll happens
     in the event handler (not the render path), so the staging contract is untouched.
     v2.2 (2026-09-04, merchant): a pick still closes its section and opens the next one,
     but NO LONGER scrolls to it ("please don't scroll down"). The reveal scroll stays on a
     manual head tap (AccordionLayout), on Review -> Edit (openStyleGroup) and on a blocked
     Next (styleValidate). */
  var openStyleGroup = function openStyleGroup(groupTitle) {
    nextTab('style');
    setActiveStyleGroup(groupTitle);
    dysRevealOpenGroup();
  };
  var advanceStyleGroup = function advanceStyleGroup(fromTitle) {
    var items = styleMeta.tab_items;
    for (var i = 0; i < items.length; i++) {
      if (items[i].item_title === fromTitle) {
        setActiveStyleGroup(i + 1 < items.length ? items[i + 1].item_title : monogramMeta.block_name);
        return;
      }
    }
  };
  var stepIndex = DYS_STEPS.indexOf(activeTab);
  var nextStepId = stepIndex < DYS_STEPS.length - 1 ? DYS_STEPS[stepIndex + 1] : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isAdminCustomer === 'true' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bs_container"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: getCombination
  }, "Get Combinations")), /*#__PURE__*/React.createElement("div", {
    className: "bs_design_your_shirt_combination_table"
  }, /*#__PURE__*/React.createElement("table", null, variantComb.map(function (item, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, index === 0 && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null, "Option Name (Add-ons)"), /*#__PURE__*/React.createElement("th", null, "Price")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, index + 1), /*#__PURE__*/React.createElement("td", null, item), /*#__PURE__*/React.createElement("td", null, variantCombPrice.length && variantCombPrice[index] + parseInt(productPrice))));
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "modal-header dys-head"
  }, /*#__PURE__*/React.createElement("img", {
    className: "dys-head__img",
    src: __DYS.image.w600,
    srcSet: __DYS.image.srcset,
    sizes: "40px",
    width: "40",
    height: "50",
    loading: "lazy",
    decoding: "async",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "dys-head__id"
  }, /*#__PURE__*/React.createElement("p", {
    className: "dys-eyebrow"
  }, "Design Your Shirt"), /*#__PURE__*/React.createElement("p", {
    className: "dys-head__name"
  }, __DYS.productTitle)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dys-head__total",
    "aria-expanded": receiptOpen,
    onClick: function onClick() {
      return setReceiptOpen(function (o) {
        return !o;
      });
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "dys-head__total-label"
  }, "Total"), /*#__PURE__*/React.createElement("span", {
    className: "dys-money"
  }, dysFormatMoney(price.ldTotalCents), /*#__PURE__*/React.createElement("svg", {
    className: "dys-head__chev".concat(receiptOpen ? ' is-open' : ''),
    viewBox: "0 0 24 24",
    width: "11",
    height: "11",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
  })))), receiptOpen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dys-head__scrim",
    "aria-label": "Close price details",
    onClick: function onClick() {
      return setReceiptOpen(false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "dys-head__sheet",
    role: "dialog",
    "aria-label": "Price details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dys-head__sheet-fab"
  }, /*#__PURE__*/React.createElement("img", {
    src: __DYS.image.w600,
    srcSet: __DYS.image.srcset,
    sizes: "36px",
    width: "36",
    height: "45",
    loading: "lazy",
    decoding: "async",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "dys-eyebrow"
  }, "Fabric"), /*#__PURE__*/React.createElement("p", {
    className: "dys-head__sheet-name"
  }, __DYS.productTitle))), /*#__PURE__*/React.createElement(PriceReceipt, {
    price: price,
    compact: true
  }))), checkHasInStorage() && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "load_saved_settings__btn",
    onClick: function onClick() {
      return loadSavedSelectionSettings();
    }
  }, "Load saved selections"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "class": ""
  }, /*#__PURE__*/React.createElement("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "modal-body dys-modal-body"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "dys-steps",
    "aria-label": "Steps"
  }, DYS_STEPS.map(function (step, i) {
    var isActive = activeTab === step;
    var isDone = i < stepIndex;
    var isLocked = i > maxStep + 1 && !isActive;
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "dys-steps__btn".concat(isActive ? ' is-active' : '').concat(isDone ? ' is-done' : ''),
      disabled: isLocked,
      "aria-current": isActive ? 'step' : undefined,
      onClick: function onClick() {
        return nextTab(step);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "dys-steps__num",
      "aria-hidden": "true"
    }, isDone ? /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "10",
      height: "10",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "3"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M20 6L9 17l-5-5"
    })) : i + 1), /*#__PURE__*/React.createElement("span", {
      className: "dys-steps__label"
    }, DYS_STEP_LABELS[step]));
  })), /*#__PURE__*/React.createElement("div", {
    className: "dys-layout"
  }, /*#__PURE__*/React.createElement(PriceRail, {
    price: price
  }), /*#__PURE__*/React.createElement("div", {
    className: "dys-main"
  },
  /* phone: the fabric identity card leads the customizer (merchant request);
     Review renders its own copy, the desktop docket already carries it */
  activeTab !== 'summary' && /*#__PURE__*/React.createElement("div", {
    className: "dys-review__fabric dys-fabcard--lead"
  }, mediaReady ? /*#__PURE__*/React.createElement("img", {
    src: __DYS.image.w600,
    srcSet: __DYS.image.srcset,
    sizes: "64px",
    width: "64",
    height: "80",
    loading: "lazy",
    decoding: "async",
    fetchpriority: "low",
    alt: ""
  }) : /*#__PURE__*/React.createElement("span", {
    className: "dys-fabcard__ph",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "dys-eyebrow"
  }, "Fabric"), /*#__PURE__*/React.createElement("p", {
    className: "dys-review__name"
  }, __DYS.productTitle))), /*#__PURE__*/React.createElement("div", {
    className: "dys-pan ".concat(activeTab === 'style' ? 'is-active' : '')
  }, activeTab === 'style' && /*#__PURE__*/React.createElement(Accordian, {
    mediaReady: mediaReady,
    styleMeta: styleMeta,
    styleSelectedData: styleSelectedData,
    monogramMeta: monogramMeta,
    monogramSelectedData: monogramSelectedData,
    onChangeStyle: onChangeStyle,
    onChangeMonogram: onChangeMonogram,
    activeIndex: activeStyleGroup,
    setActiveIndex: setActiveStyleGroup,
    advanceStyleGroup: advanceStyleGroup,
    monogramErrorsVisible: monogramErrorsVisible,
    styleErrorsVisible: styleErrorsVisible
  })), /*#__PURE__*/React.createElement("div", {
    className: "dys-pan ".concat(activeTab === 'contrast' ? 'is-active' : '')
  }, activeTab === 'contrast' && /*#__PURE__*/React.createElement(Contrast, {
    contrastMeta: contrastMeta,
    contrastSelectedData: contrastSelectedData,
    onChangeContrast: onChangeContrast
  })), /*#__PURE__*/React.createElement("div", {
    className: "dys-pan ".concat(activeTab === 'size' ? 'is-active' : '')
  }, activeTab === 'size' && /*#__PURE__*/React.createElement(Size, {
    sizeMeta: sizeMeta,
    sizeSelectedData: sizeSelectedData,
    onChangeSize: onChangeSize,
    onSizeClear: function onSizeClear() {
      return setSizeSelectedData({});
    },
    sizeOptionSelectedData: sizeOptionSelectedData,
    onChangeSizeSub: onChangeSizeSub,
    sizeErrorsVisible: sizeErrorsVisible
  })), /*#__PURE__*/React.createElement("div", {
    className: "dys-pan ".concat(activeTab === 'summary' ? 'is-active' : '')
  }, activeTab === 'summary' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Summary, {
    contrastMeta: contrastMeta,
    styleSelectedData: styleSelectedData,
    contrastSelectedData: contrastSelectedData,
    sizeSelectedData: sizeSelectedData,
    sizeOptionSelectedData: sizeOptionSelectedData,
    monogramSelectedData: monogramSelectedData,
    price: price,
    openStyleGroup: openStyleGroup,
    goToStep: function goToStep(s) {
      return nextTab(s);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "justify-center items-center mr-3 hidden"
  }, /*#__PURE__*/React.createElement("input", {
    id: "saveCurrentSelections",
    type: "checkbox",
    name: "save for latter use",
    checked: isCurrentSave,
    onChange: onChangeCurrentSave
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "saveCurrentSelections"
  }, "Save selections for future orders"))))))), /*#__PURE__*/React.createElement("div", {
    className: "dys-bar"
  }, /*#__PURE__*/React.createElement("p", {
    className: "dys-bar__error",
    role: "status",
    "aria-live": "polite"
  }, atcError || (styleErrorsVisible && activeTab === 'style' ? 'Choose an option in every section to continue.' : '')), /*#__PURE__*/React.createElement("div", {
    className: "dys-bar__row"
  }, stepIndex > 0 && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dys-back",
    onClick: function onClick() {
      return nextTab(DYS_STEPS[stepIndex - 1]);
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "14",
    height: "14",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 19.5L8.25 12l7.5-7.5"
  })), "Back"), /*#__PURE__*/React.createElement("p", {
    className: "dys-bar__total"
  }, /*#__PURE__*/React.createElement("span", {
    className: "dys-bar__total-label"
  }, "Total"), /*#__PURE__*/React.createElement("span", {
    className: "dys-money"
  }, price.ldPct > 0 && !price.unavailable && /*#__PURE__*/React.createElement("s", {
    className: "dys-was"
  }, dysFormatMoney(price.totalCents)), dysFormatMoney(price.ldTotalCents), " ", /*#__PURE__*/React.createElement("small", null, "USD"))), activeTab === 'summary' ? isLoading ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dys-cta",
    disabled: true
  }, "Adding to Cart\u2026") : /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dys-cta",
    disabled: price.unavailable,
    onClick: addToCart
  }, "Add to Cart") : /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dys-cta",
    onClick: function onClick() {
      return nextTab(nextStepId, true);
    }
  }, "Next\u200A: ", DYS_STEP_LABELS[nextStepId]))));
}
function Summary(_ref6) {
  var contrastMeta = _ref6.contrastMeta,
    styleSelectedData = _ref6.styleSelectedData,
    contrastSelectedData = _ref6.contrastSelectedData,
    sizeSelectedData = _ref6.sizeSelectedData,
    sizeOptionSelectedData = _ref6.sizeOptionSelectedData,
    monogramSelectedData = _ref6.monogramSelectedData,
    price = _ref6.price,
    openStyleGroup = _ref6.openStyleGroup,
    goToStep = _ref6.goToStep;
  /* Display-only lookups. The cart property VALUES stay raw (fabric = handle, size = the
     full authored string) — fulfillment reads those; only what the shopper sees is mapped. */
  var fabricName = function fabricName(handle) {
    for (var i = 0; i < contrastMeta.length; i++) {
      var col = contrastMeta[i].block_collection;
      if (col) for (var j = 0; j < col.length; j++) if (col[j].handle === handle) return col[j].title;
    }
    return handle;
  };
  var shortName = function shortName(v) {
    var m = /^([^(]+?)\s*\(.+\)\s*$/.exec(v);
    return m ? m[1] : v;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "dys-review"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dys-review__fabric"
  }, /*#__PURE__*/React.createElement("img", {
    src: __DYS.image.w600,
    srcSet: __DYS.image.srcset,
    sizes: "64px",
    width: "64",
    height: "80",
    loading: "lazy",
    decoding: "async",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "dys-eyebrow"
  }, "Fabric"), /*#__PURE__*/React.createElement("p", {
    className: "dys-review__name"
  }, __DYS.productTitle))), /*#__PURE__*/React.createElement("section", {
    className: "dys-review__block"
  }, /*#__PURE__*/React.createElement("header", {
    className: "dys-review__block-head"
  }, /*#__PURE__*/React.createElement("h4", null, "Style"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dys-edit",
    onClick: function onClick() {
      return openStyleGroup(styleSelectedData.length ? styleSelectedData[0].item_title : null);
    }
  }, "Edit")), /*#__PURE__*/React.createElement("dl", {
    className: "dys-review__grid"
  }, styleSelectedData.length && styleSelectedData.map(function (item) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "dys-review__cell"
    }, /*#__PURE__*/React.createElement("dt", null, item.item_title), /*#__PURE__*/React.createElement("dd", null, item.item_value || "\u2014")), item.is_paid !== null && item.is_paid && /*#__PURE__*/React.createElement("div", {
      className: "dys-review__cell"
    }, /*#__PURE__*/React.createElement("dt", null, item.item_paid_title), /*#__PURE__*/React.createElement("dd", null, item.item_paid_name, " ", /*#__PURE__*/React.createElement("span", {
      className: "dys-addon-price"
    }, "+", item.item_paid_price))));
  }))), monogramSelectedData && monogramSelectedData['Monogram'] && /*#__PURE__*/React.createElement("section", {
    className: "dys-review__block"
  }, /*#__PURE__*/React.createElement("header", {
    className: "dys-review__block-head"
  }, /*#__PURE__*/React.createElement("h4", null, "Monogram"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dys-edit",
    onClick: function onClick() {
      return openStyleGroup('Monogram');
    }
  }, "Edit")), /*#__PURE__*/React.createElement("dl", {
    className: "dys-review__grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dys-review__cell"
  }, /*#__PURE__*/React.createElement("dt", null, "Initials"), /*#__PURE__*/React.createElement("dd", null, monogramSelectedData['Monogram Text'])), /*#__PURE__*/React.createElement("div", {
    className: "dys-review__cell"
  }, /*#__PURE__*/React.createElement("dt", null, "Style"), /*#__PURE__*/React.createElement("dd", null, monogramSelectedData['Monogram Style'])), /*#__PURE__*/React.createElement("div", {
    className: "dys-review__cell"
  }, /*#__PURE__*/React.createElement("dt", null, "Color"), /*#__PURE__*/React.createElement("dd", null, monogramSelectedData['Monogram Color'])), /*#__PURE__*/React.createElement("div", {
    className: "dys-review__cell"
  }, /*#__PURE__*/React.createElement("dt", null, "Placement"), /*#__PURE__*/React.createElement("dd", null, monogramSelectedData['Monogram Placement'])))), /*#__PURE__*/React.createElement("section", {
    className: "dys-review__block"
  }, /*#__PURE__*/React.createElement("header", {
    className: "dys-review__block-head"
  }, /*#__PURE__*/React.createElement("h4", null, "Contrast"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dys-edit",
    onClick: function onClick() {
      return goToStep('contrast');
    }
  }, "Edit")), /*#__PURE__*/React.createElement("dl", {
    className: "dys-review__grid"
  }, contrastSelectedData && Object.keys(contrastSelectedData).map(function (key, i) {
    var isContrast = key.includes('Contrast');
    var lowercaseName = contrastSelectedData[key].toLowerCase();
    if (isContrast !== true) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "dys-review__cell"
      }, /*#__PURE__*/React.createElement("dt", null, key), /*#__PURE__*/React.createElement("dd", null, dysDisplayValue(contrastSelectedData[key]))), lowercaseName !== 'skip' && /*#__PURE__*/React.createElement("div", {
        className: "dys-review__cell"
      }, /*#__PURE__*/React.createElement("dt", null, key, " fabric"), /*#__PURE__*/React.createElement("dd", null, dysShortFabric(fabricName(contrastSelectedData["".concat(key, " Contrast")])))));
    }
  }))), /*#__PURE__*/React.createElement("section", {
    className: "dys-review__block"
  }, /*#__PURE__*/React.createElement("header", {
    className: "dys-review__block-head"
  }, /*#__PURE__*/React.createElement("h4", null, "Size"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dys-edit",
    onClick: function onClick() {
      return goToStep('size');
    }
  }, "Edit")), /*#__PURE__*/React.createElement("dl", {
    className: "dys-review__grid"
  }, sizeSelectedData && Object.keys(sizeSelectedData).map(function (key, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dys-review__cell"
    }, /*#__PURE__*/React.createElement("dt", null, dysShortKey(key)), /*#__PURE__*/React.createElement("dd", null, shortName(sizeSelectedData[key])));
  }), sizeOptionSelectedData && Object.keys(sizeOptionSelectedData).map(function (key, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dys-review__cell"
    }, /*#__PURE__*/React.createElement("dt", null, dysShortKey(key)), /*#__PURE__*/React.createElement("dd", null, sizeOptionSelectedData[key]));
  }))), /*#__PURE__*/React.createElement("section", {
    className: "dys-review__block dys-review__block--price"
  }, /*#__PURE__*/React.createElement("header", {
    className: "dys-review__block-head"
  }, /*#__PURE__*/React.createElement("h4", null, "Price")), /*#__PURE__*/React.createElement(PriceReceipt, {
    price: price,
    compact: true
  })), /*#__PURE__*/React.createElement(TrustBadges, null));
}
function Size(_ref7) {
  var sizeMeta = _ref7.sizeMeta,
    sizeSelectedData = _ref7.sizeSelectedData,
    onChangeSize = _ref7.onChangeSize,
    onSizeClear = _ref7.onSizeClear,
    sizeOptionSelectedData = _ref7.sizeOptionSelectedData,
    onChangeSizeSub = _ref7.onChangeSizeSub,
    sizeErrorsVisible = _ref7.sizeErrorsVisible;
  /* Display split only: "FitSure (answer 7 simple questions…)" renders as a card name +
     sub-line. The stored value (and cart property value) stays the full string. */
  var cardParts = function cardParts(title) {
    var m = /^([^(]+?)\s*\((.+)\)\s*$/.exec(title);
    var name = m ? m[1] : title;
    var sub = m ? m[2] : '';
    if (sub) sub = sub.charAt(0).toUpperCase() + sub.slice(1);
    /* display-only descriptions where the authored title carries none — the stored value
       (and cart property value) is always the full original string */
    if (!sub) {
      var n = name.toLowerCase();
      if (n.indexOf('standard') > -1) sub = 'Choose a ready size, XS to XXXL, plus your collar size.';else if (n.indexOf('custom') > -1 || n.indexOf('measure') > -1) sub = 'Enter exact measurements for a made-to-measure fit.';
    }
    return {
      name: name,
      sub: sub
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "dys-size"
  }, /*#__PURE__*/React.createElement("p", {
    className: "dys-eyebrow"
  }, "How should we size it?"), sizeErrorsVisible && !sizeSelectedData['Size'] && /*#__PURE__*/React.createElement("p", {
    className: "dys-size__pick-msg",
    role: "alert"
  }, "Choose one of the three ways below to continue."), /*#__PURE__*/React.createElement("div", {
    className: "dys-size__methods",
    role: "radiogroup",
    "aria-label": "Sizing method"
  }, sizeMeta.length && sizeMeta.map(function (item_check, item_check_index, item_check_arr) {
    var parts = cardParts(item_check.item_options[0].block_title);
    var isChosen = sizeSelectedData['Size'] === item_check.item_options[0].block_title;
    return /*#__PURE__*/React.createElement("div", {
      className: "dys-size__method".concat(isChosen ? ' is-selected' : '')
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      id: item_check.item_name,
      name: "Size",
      value: item_check.item_options[0].block_title,
      checked: isChosen,
      onChange: onChangeSize
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: item_check.item_name,
      onClick: function onClick(e) {
        if (isChosen) {
          e.preventDefault();
          onSizeClear();
        }
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "dys-size__method-name"
    }, parts.name), parts.sub && /*#__PURE__*/React.createElement("span", {
      className: "dys-size__method-sub"
    }, parts.sub)),
    /* v2.1 (2026-08-31, merchant: switching methods silently swapped the form
       below and read as confusing): the chosen method's questions render INSIDE
       its own card, so the method→questions relationship is visible and
       switching methods visibly moves the form into the new card. Container
       move only — #sizeOptionsForm, every input name/id/value and the change
       handlers are byte-identical to v1 (they are state keys and cart property
       keys; see the dossier §4). */
    isChosen && /*#__PURE__*/React.createElement("div", {
      className: "dys-size__panel"
    }, /*#__PURE__*/React.createElement("p", {
      className: "dys-size__panel-head"
    }, parts.name), /*#__PURE__*/React.createElement("form", {
      id: "sizeOptionsForm",
      className: sizeErrorsVisible ? 'dys-show-errors' : ''
    }, /*#__PURE__*/React.createElement("div", {
      className: "dys-size__qs"
    }, item_check.item_options.length && item_check.item_options.map(function (sub_opt, sub_opt_index, sub_opt_arr) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "dys-size__q"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "dys-size__q-title"
      }, sub_opt.block_option_title), /*#__PURE__*/React.createElement("div", {
        className: "dys-size__q-body ".concat(sub_opt.block_input_type === 'swatch' ? 'is-swatch' : sub_opt.block_input_type === 'dropdown' ? 'is-dropdown' : 'is-fields')
      }, sub_opt.block_input_type === 'swatch' && sub_opt.block_options.length && sub_opt.block_options.map(function (sup_sub_opt, sup_sub_opt_index, sup_sub_opt_arr) {
        return /*#__PURE__*/React.createElement("div", {
          className: "dys-chip"
        }, /*#__PURE__*/React.createElement("input", {
          type: "radio",
          required: true,
          id: sub_opt.block_name + '-' + sub_opt.block_option_title + '-' + sup_sub_opt.title,
          name: sub_opt.block_option_title,
          value: sup_sub_opt.title,
          checked: sizeOptionSelectedData[sub_opt.block_option_title] === sup_sub_opt.title,
          onChange: onChangeSizeSub
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: sub_opt.block_name + '-' + sub_opt.block_option_title + '-' + sup_sub_opt.title
        }, sup_sub_opt.title));
      }), sub_opt.block_input_type === 'swatch' && !sizeOptionSelectedData[sub_opt.block_option_title] && /*#__PURE__*/React.createElement("p", {
        className: "required-msg"
      }, "Please pick one"), sub_opt.block_input_type === 'input_field' && sub_opt.block_options.length && sub_opt.block_options.map(function (sup_sub_opt, sup_sub_opt_index, sup_sub_opt_arr) {
        return /*#__PURE__*/React.createElement("div", {
          className: "dys-field"
        }, /*#__PURE__*/React.createElement("input", {
          required: true,
          type: "number",
          id: sub_opt.block_name + '-' + sub_opt.block_option_title + '-' + sup_sub_opt.title,
          name: "".concat(sub_opt.block_option_title, " (").concat(sup_sub_opt.title, ")"),
          placeholder: sup_sub_opt.title,
          value: sizeOptionSelectedData["".concat(sub_opt.block_option_title, " (").concat(sup_sub_opt.title, ")")],
          onChange: onChangeSizeSub
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: sub_opt.block_name + '-' + sub_opt.block_option_title + '-' + sup_sub_opt.title,
          "data-content": sup_sub_opt.title,
          className: "label"
        }, /*#__PURE__*/React.createElement("span", null, sup_sub_opt.title)), !sizeOptionSelectedData["".concat(sub_opt.block_option_title, " (").concat(sup_sub_opt.title, ")")] && /*#__PURE__*/React.createElement("p", {
          className: "required-msg"
        }, "Number only"));
      }), sub_opt.block_input_type === 'dropdown' && /*#__PURE__*/React.createElement("div", {
        className: "dys-select"
      }, /*#__PURE__*/React.createElement("select", {
        required: true,
        value: sizeOptionSelectedData[sub_opt.block_option_title],
        name: sub_opt.block_option_title,
        onChange: onChangeSizeSub
      }, /*#__PURE__*/React.createElement("option", {
        value: "",
        disabled: true,
        selected: true
      }, "Select"), sub_opt.block_options.length && sub_opt.block_options.map(function (sup_sub_opt, sup_sub_opt_index, sup_sub_opt_arr) {
        return /*#__PURE__*/React.createElement("option", {
          value: sup_sub_opt.title
        }, sup_sub_opt.title);
      })), /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor",
        "class": "dys-select__chev"
      }, /*#__PURE__*/React.createElement("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
      })), !sizeOptionSelectedData[sub_opt.block_option_title] && /*#__PURE__*/React.createElement("p", {
        className: "required-msg"
      }, "Please select one")))));
    })))));
  })));
}
function Contrast(_ref8) {
  var contrastMeta = _ref8.contrastMeta,
    contrastSelectedData = _ref8.contrastSelectedData,
    onChangeContrast = _ref8.onChangeContrast;
  return /*#__PURE__*/React.createElement("div", {
    className: "dys-contrast"
  }, /*#__PURE__*/React.createElement("p", {
    className: "dys-contrast__intro"
  }, "Add a second fabric to the inside or outside of the collar, cuffs or placket. Contrast is free \u2014 skip any of them."), contrastMeta.length && contrastMeta.map(function (item, index, arr) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dys-contrast__group"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dys-contrast__titlerow"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "dys-contrast__title"
    }, item.block_title), /*#__PURE__*/React.createElement("span", {
      className: "dys-contrast__val"
    }, function () {
      var pl = contrastSelectedData[item.block_title];
      if (!pl || pl === 'Skip') return 'None';
      var fh = contrastSelectedData[item.block_title + ' ' + item.block_name];
      var fp = item.block_collection ? item.block_collection.find(function (x) {
        return x.handle === fh;
      }) : null;
      return fp ? "".concat(dysDisplayValue(pl), " \xB7 ").concat(dysShortFabric(fp.title)) : dysDisplayValue(pl);
    }())), /*#__PURE__*/React.createElement("div", {
      className: "dys-contrast__chips"
    }, item.block_options.length && item.block_options.map(function (opt, opt_index, opt_arr) {
      return /*#__PURE__*/React.createElement("div", {
        className: "dys-chip"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: item.block_name + '-' + item.block_title + '-' + opt.title,
        name: item.block_title,
        value: opt.title,
        checked: contrastSelectedData[item.block_title] === opt.title,
        onChange: onChangeContrast
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: item.block_name + '-' + item.block_title + '-' + opt.title
      }, dysDisplayValue(opt.title)));
    })), contrastSelectedData[item.block_title] && contrastSelectedData[item.block_title] !== 'Skip' && !item.block_collection && item.block_collection_handle && /*#__PURE__*/React.createElement("p", {
      className: "dys-contrast__intro",
      role: "status"
    }, item.block_collection_error ? 'Fabrics could not load. Please refresh the page.' : 'Loading fabrics…'), contrastSelectedData[item.block_title] !== 'Skip' && /*#__PURE__*/React.createElement("div", {
      className: "dys-contrast__fabrics"
    }, (item === null || item === void 0 ? void 0 : item.block_collection) && item.block_collection.length > 0 && item.block_collection.map(function (opt_sub, opt_sub_index, opt_sub_arr) {
      return /*#__PURE__*/React.createElement("div", {
        className: "dys-tile dys-tile--fabric"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        name: item.block_title + ' ' + item.block_name,
        id: item.block_name + '-' + item.block_title + '-' + opt_sub.title,
        value: opt_sub.handle,
        checked: contrastSelectedData[item.block_title + ' ' + item.block_name] === opt_sub.handle,
        onChange: onChangeContrast
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: item.block_name + '-' + item.block_title + '-' + opt_sub.title
      }, opt_sub.img_src ? /*#__PURE__*/React.createElement("img", {
        src: opt_sub.img_src,
        width: "72",
        height: "72",
        loading: "lazy",
        decoding: "async",
        alt: ""
      }) : /*#__PURE__*/React.createElement("span", {
        className: "dys-tile__noimg",
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("span", {
        className: "dys-tile__name"
      }, dysShortFabric(opt_sub.title))));
    })));
  }));
}
function Accordian(_ref9) {
  var _monogramMeta$block_p, _monogramMeta$block_p2;
  var mediaReady = _ref9.mediaReady,
    styleMeta = _ref9.styleMeta,
    styleSelectedData = _ref9.styleSelectedData,
    monogramMeta = _ref9.monogramMeta,
    monogramSelectedData = _ref9.monogramSelectedData,
    onChangeStyle = _ref9.onChangeStyle,
    onChangeMonogram = _ref9.onChangeMonogram,
    activeIndex = _ref9.activeIndex,
    setActiveIndex = _ref9.setActiveIndex,
    advanceStyleGroup = _ref9.advanceStyleGroup,
    monogramErrorsVisible = _ref9.monogramErrorsVisible,
    styleErrorsVisible = _ref9.styleErrorsVisible;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "dys-groups".concat(styleErrorsVisible ? ' has-errors' : '')
  }, styleMeta && styleMeta.tab_items.map(function (item, index, arr) {
    var _styleSelectedData$in2, _styleSelectedData$in3, _styleSelectedData$in4, _item$item_paid6, _item$item_paid7, _styleSelectedData$in5, _item$item_paid8, _item$item_paid9;
    return /*#__PURE__*/React.createElement(AccordionLayout, {
      index: item.item_title,
      activeIndex: activeIndex,
      setActiveIndex: setActiveIndex
    }, /*#__PURE__*/React.createElement(AccordionHeader, null, /*#__PURE__*/React.createElement(React.Fragment, null, function () {
      var selOpt = item.item_options.find(function (o) {
        var _styleSelectedData$in;
        return o.title === ((_styleSelectedData$in = styleSelectedData[index]) === null || _styleSelectedData$in === void 0 ? void 0 : _styleSelectedData$in.item_value);
      });
      return mediaReady && selOpt && selOpt.vector_src ? /*#__PURE__*/React.createElement("img", {
        className: "dys-group__thumb",
        src: dysThumbUrl(selOpt.vector_src, 64),
        width: "28",
        height: "28",
        loading: "lazy",
        decoding: "async",
        fetchpriority: "low",
        alt: ""
      }) : /*#__PURE__*/React.createElement("span", {
        className: "dys-group__thumb dys-group__thumb--empty",
        "aria-hidden": "true"
      });
    }(), /*#__PURE__*/React.createElement("h5", {
      className: "dys-group__title"
    }, item.item_title), /*#__PURE__*/React.createElement("p", {
      className: "dys-group__value".concat((_styleSelectedData$in2 = styleSelectedData[index]) !== null && _styleSelectedData$in2 !== void 0 && _styleSelectedData$in2.item_value ? '' : ' dys-group__value--none')
    }, ((_styleSelectedData$in3 = styleSelectedData[index]) === null || _styleSelectedData$in3 === void 0 ? void 0 : _styleSelectedData$in3.item_value) || "\u2014"), !((_styleSelectedData$in4 = styleSelectedData[index]) !== null && _styleSelectedData$in4 !== void 0 && _styleSelectedData$in4.item_value) && /*#__PURE__*/React.createElement("span", {
      className: "dys-group__req"
    }, "Pick one"), /*#__PURE__*/React.createElement("svg", {
      className: "dys-group__chev",
      viewBox: "0 0 24 24",
      width: "14",
      height: "14",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
    })))), /*#__PURE__*/React.createElement(AccordionBody, null, /*#__PURE__*/React.createElement("div", {
      className: "dys-group__body"
    }, (item === null || item === void 0 ? void 0 : item.item_paid) && (item === null || item === void 0 ? void 0 : item.item_paid) && /*#__PURE__*/React.createElement("div", {
      className: "dys-addon-row"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: (item === null || item === void 0 || (_item$item_paid6 = item.item_paid) === null || _item$item_paid6 === void 0 ? void 0 : _item$item_paid6.product_hanlde) + '-paid_item',
      name: item.item_title + ' Add-on',
      value: item === null || item === void 0 || (_item$item_paid7 = item.item_paid) === null || _item$item_paid7 === void 0 ? void 0 : _item$item_paid7.product_name,
      checked: (_styleSelectedData$in5 = styleSelectedData[index]) === null || _styleSelectedData$in5 === void 0 ? void 0 : _styleSelectedData$in5.is_paid,
      onChange: function onChange(e) {
        return onChangeStyle(e, index);
      }
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: (item === null || item === void 0 || (_item$item_paid8 = item.item_paid) === null || _item$item_paid8 === void 0 ? void 0 : _item$item_paid8.product_hanlde) + '-paid_item'
    }, /*#__PURE__*/React.createElement("span", {
      className: "dys-addon-row__box",
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("span", null, item === null || item === void 0 ? void 0 : item.item_paid.product_name), /*#__PURE__*/React.createElement("span", {
      className: "dys-addon-price"
    }, "+", item === null || item === void 0 || (_item$item_paid9 = item.item_paid) === null || _item$item_paid9 === void 0 ? void 0 : _item$item_paid9.product_price))), /*#__PURE__*/React.createElement("div", {
      className: "dys-tiles"
    }, item.item_options.length && item.item_options.map(function (opt_item, opt_index, opt_arr) {
      var _styleSelectedData$in6;
      // NOTE: the radio `name` below MUST stay namespaced ('style-' + title).
      // The Contrast tab renders blocks titled Collar / Cuff / Placket whose
      // radios use the BARE title as their name, so a bare title here collided
      // on "Collar": all 20 radios became one native group, only one could be
      // checked, and React's chosen option lost its `checked` DOM property —
      // the tile showed nothing until a second click. This name is inert
      // (onChangeStyle writes by index; nothing queries it), whereas the
      // Contrast/Size names ARE state keys and must never be renamed.
      // See me/docs/dys-customizer.md
      return /*#__PURE__*/React.createElement("div", {
        className: "dys-tile"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        name: 'style-' + item.item_title,
        id: item.item_title + '-' + opt_item.handle,
        value: opt_item.title,
        checked: ((_styleSelectedData$in6 = styleSelectedData[index]) === null || _styleSelectedData$in6 === void 0 ? void 0 : _styleSelectedData$in6.item_value) === opt_item.title,
        onChange: function onChange(e) {
          onChangeStyle(e, index);
          advanceStyleGroup(item.item_title);
        }
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: item.item_title + '-' + opt_item.handle
      }, opt_item.vector_src ? /*#__PURE__*/React.createElement("img", {
        src: dysThumbUrl(opt_item.vector_src, 160),
        srcSet: dysThumbUrl(opt_item.vector_src, 160) + ' 1x, ' + dysThumbUrl(opt_item.vector_src, 320) + ' 2x',
        width: "96",
        height: "96",
        loading: "lazy",
        decoding: "async",
        alt: ""
      }) : /*#__PURE__*/React.createElement("span", {
        className: "dys-tile__noimg",
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("span", {
        className: "dys-tile__name"
      }, opt_item.title), opt_item.paid_item && /*#__PURE__*/React.createElement("span", {
        className: "dys-addon-price"
      }, "+", opt_item.paid_item.product_price)));
    })))));
  }), monogramMeta && /*#__PURE__*/React.createElement(AccordionLayout, {
    index: monogramMeta.block_name,
    activeIndex: activeIndex,
    setActiveIndex: setActiveIndex,
    keepMounted: !!monogramSelectedData[monogramMeta.block_name]
  }, /*#__PURE__*/React.createElement(AccordionHeader, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "dys-group__thumb dys-group__thumb--empty",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("h5", {
    className: "dys-group__title"
  }, monogramMeta.block_name), /*#__PURE__*/React.createElement("p", {
    className: "dys-group__value"
  }, monogramSelectedData[monogramMeta.block_name] ? monogramSelectedData[monogramMeta.block_name + ' Text'] || 'Added' : 'None'), /*#__PURE__*/React.createElement("svg", {
    className: "dys-group__chev",
    viewBox: "0 0 24 24",
    width: "14",
    height: "14",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
  })))), /*#__PURE__*/React.createElement(AccordionBody, null, /*#__PURE__*/React.createElement("div", {
    className: "dys-group__body dys-monogram".concat(monogramErrorsVisible ? ' dys-show-errors' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "dys-addon-row"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: monogramMeta.block_name + '-toggle',
    name: monogramMeta.block_name,
    checked: monogramSelectedData[monogramMeta.block_name],
    onChange: onChangeMonogram
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: monogramMeta.block_name + '-toggle'
  }, /*#__PURE__*/React.createElement("span", {
    className: "dys-addon-row__box",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", null, "Add ", monogramMeta.block_name), ((_monogramMeta$block_p = monogramMeta.block_product) === null || _monogramMeta$block_p === void 0 ? void 0 : _monogramMeta$block_p.product_price) && /*#__PURE__*/React.createElement("span", {
    className: "dys-addon-price"
  }, "+", (_monogramMeta$block_p2 = monogramMeta.block_product) === null || _monogramMeta$block_p2 === void 0 ? void 0 : _monogramMeta$block_p2.product_price))), monogramSelectedData[monogramMeta.block_name] && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    id: "monogramFormRef"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dys-field dys-field--initials"
  }, /*#__PURE__*/React.createElement("input", {
    required: true,
    type: "text",
    maxlength: "3",
    id: monogramMeta.block_name + '-textfiled',
    name: monogramMeta.block_name + ' Text',
    placeholder: "Initials",
    value: monogramSelectedData[monogramMeta.block_name + ' Text'],
    onChange: onChangeMonogram
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: monogramMeta.block_name + '-textfiled',
    "data-content": "Initials",
    className: "label"
  }, /*#__PURE__*/React.createElement("span", null, "Initials")), !monogramSelectedData[monogramMeta.block_name + ' Text'] && /*#__PURE__*/React.createElement("p", {
    className: "required-msg"
  }, "1\u20133 characters"))), monogramMeta.block_option_1 && /*#__PURE__*/React.createElement("div", {
    className: "dys-monogram__axis"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "dys-monogram__axis-title"
  }, monogramMeta.block_option_1.title), /*#__PURE__*/React.createElement("div", {
    className: "dys-tiles dys-tiles--mono"
  }, monogramMeta.block_option_1.options.length && monogramMeta.block_option_1.options.map(function (opt_item, opt_index, opt_arr) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dys-tile"
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: "".concat(monogramMeta.block_name, " ").concat(monogramMeta.block_option_1.title),
      id: monogramMeta.block_option_1.title + '-' + opt_item.handle,
      value: opt_item.title,
      checked: monogramSelectedData["".concat(monogramMeta.block_name, " ").concat(monogramMeta.block_option_1.title)] === opt_item.title,
      onChange: onChangeMonogram
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: monogramMeta.block_option_1.title + '-' + opt_item.handle
    }, monogramMeta.block_option_1.vectors.length !== 0 && monogramMeta.block_option_1.vectors[opt_index] && /*#__PURE__*/React.createElement("img", {
      src: dysThumbUrl(monogramMeta.block_option_1.vectors[opt_index], 160),
      width: "72",
      height: "72",
      loading: "lazy",
      decoding: "async",
      alt: ""
    }), /*#__PURE__*/React.createElement("span", {
      className: "dys-tile__name"
    }, opt_item.title)));
  }))), monogramMeta.block_option_2 && /*#__PURE__*/React.createElement("div", {
    className: "dys-monogram__axis"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "dys-monogram__axis-title"
  }, monogramMeta.block_option_2.title), /*#__PURE__*/React.createElement("div", {
    className: "dys-tiles dys-tiles--mono"
  }, monogramMeta.block_option_2.options.length && monogramMeta.block_option_2.options.map(function (opt_item, opt_index, opt_arr) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dys-tile"
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: "".concat(monogramMeta.block_name, " ").concat(monogramMeta.block_option_2.title),
      id: monogramMeta.block_option_2.title + '-' + opt_item.handle,
      value: opt_item.title,
      checked: monogramSelectedData["".concat(monogramMeta.block_name, " ").concat(monogramMeta.block_option_2.title)] === opt_item.title,
      onChange: onChangeMonogram
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: monogramMeta.block_option_2.title + '-' + opt_item.handle
    }, monogramMeta.block_option_2.vectors.length !== 0 && monogramMeta.block_option_2.vectors[opt_index] && /*#__PURE__*/React.createElement("img", {
      src: dysThumbUrl(monogramMeta.block_option_2.vectors[opt_index], 160),
      width: "72",
      height: "72",
      loading: "lazy",
      decoding: "async",
      alt: ""
    }), /*#__PURE__*/React.createElement("span", {
      className: "dys-tile__name"
    }, opt_item.title)));
  }))), monogramMeta.block_option_3 && /*#__PURE__*/React.createElement("div", {
    className: "dys-monogram__axis"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "dys-monogram__axis-title"
  }, monogramMeta.block_option_3.title), /*#__PURE__*/React.createElement("div", {
    className: "dys-tiles dys-tiles--mono"
  }, monogramMeta.block_option_3.options.length && monogramMeta.block_option_3.options.map(function (opt_item, opt_index, opt_arr) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dys-tile"
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      name: "".concat(monogramMeta.block_name, " ").concat(monogramMeta.block_option_3.title),
      id: monogramMeta.block_option_3.title + '-' + opt_item.handle,
      value: opt_item.title,
      checked: monogramSelectedData["".concat(monogramMeta.block_name, " ").concat(monogramMeta.block_option_3.title)] === opt_item.title,
      onChange: onChangeMonogram
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: monogramMeta.block_option_3.title + '-' + opt_item.handle
    }, monogramMeta.block_option_3.vectors.length !== 0 && monogramMeta.block_option_3.vectors[opt_index] && /*#__PURE__*/React.createElement("img", {
      src: dysThumbUrl(monogramMeta.block_option_3.vectors[opt_index], 160),
      width: "72",
      height: "72",
      loading: "lazy",
      decoding: "async",
      alt: ""
    }), /*#__PURE__*/React.createElement("span", {
      className: "dys-tile__name"
    }, opt_item.title)));
  })))))))));
}
function AccordionLayout(_ref10) {
  var children = _ref10.children,
    index = _ref10.index,
    activeIndex = _ref10.activeIndex,
    setActiveIndex = _ref10.setActiveIndex,
    keepMounted = _ref10.keepMounted;
  var handleSetIndex = function handleSetIndex(index) {
    if (activeIndex !== index) {
      setActiveIndex(index);
      dysRevealOpenGroup();
    } else setActiveIndex(null);
  };
  var isOpen = activeIndex === index;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "dys-group".concat(isOpen ? ' is-open' : '')
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dys-group__head",
    "aria-expanded": isOpen,
    onClick: function onClick() {
      return handleSetIndex(index);
    }
  }, children[0]), /*#__PURE__*/React.createElement("div", {
    className: "dys-group__panel",
    "aria-hidden": !isOpen
  }, isOpen || keepMounted ? children.slice(1) : null)));
}
function AccordionHeader(_ref11) {
  var children = _ref11.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
function AccordionBody(_ref12) {
  var children = _ref12.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
var container = document.getElementById('design_your_shirt_modal_content');
if (container) {
  var root = ReactDOM.createRoot(container);
  root.render( /*#__PURE__*/React.createElement(App, null));
}